import Cookies from 'js-cookie';

export type LoginStateV3 =
  | LoggedOutStateV3
  | LoginErrorStateV3
  | LoggedInStateV3;

export interface LoggedOutStateV3 {
  readonly status: 'logged-out';
}

export interface LoginErrorStateV3 {
  readonly status: 'login-error';
}

export interface LoggedInStateV3 extends LoginStateV2 {
  readonly status: 'logged-in';
}

export interface LoginStateV2 {
  readonly uid: string;
  readonly customerType: 'private' | 'commercial';
}

export function parseLoginState(cookieName: string): LoginStateV3 {
  const cookieData = Cookies.get(cookieName);

  if (cookieData) {
    try {
      const value = JSON.parse(cookieData);

      if (typeof value === `object` && value !== null) {
        if (
          typeof value.uid === `string` &&
          (value.customerType === `private` ||
            value.customerType === `commercial`)
        ) {
          return {
            status: `logged-in`,
            uid: value.uid,
            customerType: value.customerType,
          };
        } else if (value.status === `login-error`) {
          return {status: `login-error`};
        }
      }
    } catch {}
  }

  return {status: `logged-out`};
}
